import React, { useContext } from "react";
import { Table } from "antd";
import TableCard from "../../../../../../components/TableCard";
import TablePagination from "../../../../../../components/TablePagination";
import { ThemeContext } from "../../../../../../contexts/ThemeContext";

interface IProps {
    tableData: Array<any>;
    columns: any[];
    isLoading: boolean;
    pagination: { current: number; pageSize: number };
    setPagination: React.Dispatch<React.SetStateAction<{ current: number; pageSize: number }>>;
}

export default function TabTaxesAuto({
    tableData,
    columns,
    isLoading,
    pagination,
    setPagination,
}: IProps) {
    const { theme } = useContext<any>(ThemeContext);
    const isDark = theme === "dark";

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {tableData.length > 10 && (
                <TablePagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={tableData.length}
                    itemName="impostos"
                    pageSizeOptions={["10", "25", "50", "100"]}
                    onChange={(page: number, pageSize: number) => setPagination({ current: page, pageSize })}
                />
            )}

            <TableCard>
                <Table
                    rowKey="id"
                    size="middle"
                    className={`modern-data-table ${isDark ? "modern-data-table-dark" : ""}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    scroll={{ x: "max-content" }}
                    pagination={
                        tableData.length > 10
                            ? {
                                  current: pagination.current,
                                  pageSize: pagination.pageSize,
                                  position: [],
                              }
                            : false
                    }
                />
            </TableCard>

            {tableData.length > 10 && (
                <TablePagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={tableData.length}
                    itemName="impostos"
                    pageSizeOptions={["10", "25", "50", "100"]}
                    onChange={(page: number, pageSize: number) => setPagination({ current: page, pageSize })}
                />
            )}
        </div>
    );
}
